module.exports = __webpack_public_path__ + "img/big4-15.93d0733c.jpg";